var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 9.14282L5.4707 30.1714L15.5001 24.9143L25.5295 30.1714L15.5001 9.14282Z",
    stroke: "#E7EDF2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.1428V9.14282L25.5294 30.1714L15.5 25.1428Z",
    fill: "#E7EDF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.853 4.18726C6.58029 5.76083 2.73535 10.6588 2.73535 16.4572C2.73535 19.5579 3.83484 22.4011 5.6642 24.6162L6.37985 23.0912C5.03109 21.2287 4.23535 18.9367 4.23535 16.4572C4.23535 11.4942 7.42332 7.28254 11.853 5.7627V4.18726ZM19.1471 5.76271C23.5768 7.28256 26.7647 11.4942 26.7647 16.4572C26.7647 18.9367 25.969 21.2287 24.6202 23.0912L25.3359 24.6162C27.1653 22.4011 28.2647 19.5579 28.2647 16.4572C28.2647 10.6588 24.4198 5.76085 19.1471 4.18727V5.76271ZM12.2852 28.8478L14.4779 27.7113C14.8146 27.7417 15.1555 27.7572 15.5 27.7572C15.8446 27.7572 16.1855 27.7417 16.5222 27.7113L18.7149 28.8478C17.6878 29.115 16.6105 29.2572 15.5 29.2572C14.3896 29.2572 13.3123 29.115 12.2852 28.8478Z",
    fill: "#E7EDF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1765 16.4571C29.1765 15.7886 29.1288 15.1312 29.0366 14.4883L31 16.4571L29.0366 18.426C29.1287 17.7831 29.1765 17.1257 29.1765 16.4571ZM15.5 30.1714C16.1667 30.1714 16.8222 30.1236 17.4634 30.0312L15.5 32L13.5366 30.0312C14.1778 30.1236 14.8333 30.1714 15.5 30.1714ZM1.82353 16.4571C1.82353 17.1257 1.87124 17.783 1.96342 18.426L0 16.4571L1.96341 14.4883C1.87123 15.1313 1.82353 15.7886 1.82353 16.4571Z",
    fill: "#E7EDF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8751 1.4458V7.1333H16.5079L14.4962 3.59424V7.1333H13.1251V1.4458H14.4962L16.5079 4.98486V1.4458H17.8751Z",
    fill: "#E7EDF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNorth);
export default __webpack_public_path__ + "static/media/dark-north.d4f45eea.svg";
export { ForwardRef as ReactComponent };